import { Box, Stack } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import InputSelectMobile from '../../../../../../components/Input/Mobile/Select';
import { FaClipboardList } from 'react-icons/fa';
import { useRequestGetExemptionType } from '../../../../../../services/hooks/Exemptions/useRequestGetExemptionType';
import React, { useMemo } from 'react';
import NisFormMobile from './Nis';
import HeaderSectionMobilePage from '../../../../../../components/Mobile/headerSection';
import BloodDonorFormMobile from './bloodDonor';
import EconomicHyposufficiency from '../../../Forms/EconomicHyposufficiency';
import {
  getExemptionType,
  isBoneMarrowExemption,
  isEconomicExemption,
  isCadunicoExemption,
} from '../../../../../../services/hooks/Exemptions/economicHyposufficiency';
import { UseRegistration } from '../../../../../../Store/useRegistration';
import { useGetRegistration } from '../../../../../../services/hooks/Registration/useGetRegistration';

interface IOwnProps {
  selectiveProcessId: string;
  isUpdating?: boolean;
  requestNis?: boolean;
  requestNisDocument?: boolean;
  requestRedome?: boolean;
}

const FormCreateExemptionMobile: React.FC<IOwnProps> = ({
  selectiveProcessId,
  isUpdating = false,
  requestNis = false,
  requestNisDocument = false,
  requestRedome = false,
}) => {
  const { watch, setValue, clearErrors } = useFormContext();
  const { registrationId } = UseRegistration();
  const registration = useGetRegistration(isUpdating ? registrationId || '' : '');
  const accent = '#222';

  const getExemption = useRequestGetExemptionType(selectiveProcessId || '');
  const selectedExemption = getExemptionType(watch('type_exemption'), getExemption.data);

  const HendleConditionalRender = useMemo(() => {
    if (selectedExemption) {
      const formToShow = selectedExemption;
      if (isEconomicExemption(formToShow?.name)) return <EconomicHyposufficiency />;
      if (isBoneMarrowExemption(formToShow?.name)) {
        return <BloodDonorFormMobile redomeCodeRequired={requestRedome} />;
      }
      if (isCadunicoExemption(formToShow?.name)) {
        return <NisFormMobile nisRequired={requestNis} documentRequired={requestNisDocument} />;
      }
      return <NisFormMobile nisRequired={false} documentRequired={false} />;
    }
  }, [selectedExemption?.id, selectedExemption?.name, requestNis, requestNisDocument, requestRedome]);

  return (
    <Stack mt={3} gap={5}>
      <HeaderSectionMobilePage>Dados da solicitação de isenção</HeaderSectionMobilePage>
      <Box>
        <InputSelectMobile
          name="type_exemption"
          placeholderLabel="Selecione o tipo de isenção"
          iconLeft={<FaClipboardList size={14} color={accent} />}
          isRequired
          listItens={getExemption.data}
          selectedItem={selectedExemption}
          fontSize={12}
          onChangeItem={(item) => {
            clearErrors([
              'type_exemption',
              'subtype',
              'documents',
              'existingExemptionAttachments',
              'removedExemptionAttachmentIds',
              'attachmentExemption',
              'nis',
              'redome_code',
            ]);
            setValue('subtype', '', { shouldDirty: true, shouldValidate: false });
            setValue('documents', [], { shouldDirty: true, shouldValidate: false });
            setValue('attachmentExemption', [], { shouldDirty: true, shouldValidate: false });
            setValue('nis', '', { shouldDirty: true, shouldValidate: false });
            setValue('redome_code', '', { shouldDirty: true, shouldValidate: false });
            const originalType = registration.data?.analysis_exemption?.type;
            setValue('removedExemptionAttachmentIds',
              originalType && item?.id !== originalType.id
                ? (registration.data?.analysis_exemption?.attachments || []).map((attachment) => attachment.id)
                : [], { shouldDirty: true, shouldValidate: false });
          }}
        />
      </Box>
      {HendleConditionalRender}
    </Stack>
  );
};

export default FormCreateExemptionMobile;
